module.exports = __webpack_public_path__ + "images/redundancy.8cfc1dcbedec6683f9c1b1301f14e5bc.svg";